import { useEffect } from 'react';
import { authActions } from '@actions';

const RENEWAL_INTERVAL = 12 * 60 * 60 * 1000;

export const useSessionRenewal = (signedIn: boolean): void => {
    useEffect(() => {
        if (!signedIn) {
            return undefined;
        }

        const timer = window.setInterval(() => authActions.renewSession(), RENEWAL_INTERVAL);
        return () => window.clearInterval(timer);
    }, [signedIn]);
};
